import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: theme.spacing(3),
  },
  title: {
    fontWeight: 600,
  },
}));
